import { apis } from "../services/apiService";
import configData from "../Config";
import CryptoJS from "crypto-js";
import useSelector from "../store/selector";
import { encryptText, decryptText } from "./cryptography";
import { CONSTANTS } from "./constant";
// import useSelector from "../store/selector";
// const selectorVal = Selector();

export const constant = {
  LOGIN_VALUE: "dfkvnjrehhvjkhvfdkjq",
  LOGOUT_VALUE: "werywiuhydiucohdrytr",
  LOGINLOGOUT_KEY: "sdfvcxkjvbcx",
  LIGHT_THEME: "light",
  DARK_THEME: "dark",
  atomsName: {
    // in this object we can add multiple atoms name
    USER_DETAIL: "userDetail",
    USER_BLOCKER: "userBlocker",
    APP_THEME: "appTheme",
    GST_DETAILS: "userGSTDetails",
    UDYAM_DETAILS: "userUdyamDetails",
    AADHAR_DETAILS: "userAadharDetails",
  },
};

export const encryptData = async (originalText) =>
  await encryptText(originalText);

export const decryptData = async (encryptedText) => {
  // console.log("decryption data ---", await decryptText(encryptedText));
  return await decryptText(encryptedText);
};

export const credentialNotReqForthisURL = [
  // LMS starts here
  "/payotp_p",
  // "/repaymentLMS",
  // "/PaymentSuccess",
  // LMS ends here
  // "/error",
  "/otp_p",
  "/signup",
];

export const capitalizeFirstLetter = (inputString) => {
  if (inputString.length === 0) {
    return inputString; // Return unchanged if the string is empty
  }
  const firstLetter = inputString[0].toUpperCase();
  const restOfLetters = inputString.substring(1).toLowerCase();
  return firstLetter + restOfLetters;
};
export const convertToLowerCase = (inputString) => {
  if (inputString?.length === 0) {
    return inputString; // Return unchanged if the string is empty
  }
  return inputString?.toLowerCase();
};

export const validatePin = async (reqData, setLoading, setFinalErr) => {
  try {
    setLoading(true);
    let resp = await apis.postApi(
      configData.API_URL + "ApplicationFlow/IsPincodeServicable",
      reqData
    );
    let result = await resp.json();
    if (resp?.status === 200) {
      // console.log("checl result in utils---", result);
      setLoading(false);
      setFinalErr("");
      return result?.data;
    }
  } catch (error) {
    const errorResult = JSON.parse(error?.message);
    setFinalErr(errorResult?.statusMessage);
    setLoading(false);
    return errorResult?.statusMessage;
  }
};

export const loggerStore = async (appId, message, status) => {
  try {
    const reqData = {
      data: `appId = ${appId}|appType = USL FrontEnd|status = ${status}|message = ${message}`,
    };
    let resp = await apis.postApi(
      configData.API_URL + "BRE/UslLogger",
      reqData
    );
    // console.log(resp);
    return resp.text();
  } catch (error) {
    // console.log("error---", error);
  }
};

export const login = async (data) => {
  const {
    screen = "los",
    source,
    anchor,
    program,
    mobileNum,
    authToken,
    loginLogoutVal = constant.LOGIN_VALUE,
  } = data;
  return {
    screen: await encryptData(screen),
    source: await encryptData(source),
    anchor: await encryptData(anchor),
    program: await encryptData(program),
    mobileNum: await encryptData(mobileNum),
    authToken: authToken,
    [constant.LOGINLOGOUT_KEY]: await encryptData(loginLogoutVal), //it is used for to identify that user is logged in, it just a random key and value
  };
};

export const logout = async (data) => {
  let loginDetail = { ...data };
  loginDetail[constant.LOGINLOGOUT_KEY] = await encryptData(
    constant.LOGOUT_VALUE
  ); // in logout we update this value
  // console.log("logout function called----", multiDecryption(loginDetail));
  delete loginDetail.mobileNum;
  // console.log("check after delete ---", loginDetail);
  return loginDetail;
};

export const multiDecryption = async (encryptDataObj) => {
  // console.log("multiDecryption---", encryptDataObj);
  if (typeof encryptDataObj === "object") {
    // console.log("object data");
    let decryptedDataObj = {};
    for (const key in encryptDataObj) {
      // console.log("loop data------", encryptDataObj[key]);
      decryptedDataObj[key] = await decryptData(encryptDataObj[key]);
    }
    // console.log("decccdaa--------", decryptedDataObj);
    return decryptedDataObj;
  } else {
    // console.log("error");
  }
};

export const autoLogout = async (setCallLogoutFun) => {
  setCallLogoutFun(true);
};
// export const autoLogout = async (dataVal) => {   // we have moved this function on app.js file
//   console.log("autologout func");
//   // let logoutFun = logout();
//   let data = await multiDecryption(dataVal);
//   console.log("autologin decp data---", data);
//   window.location.href =
//     data?.screen === "pay"
//       ? `/Pay/${data?.source}/${data?.anchor}/${data?.program}`
//       : `/${data?.source}/${data?.anchor}/${data?.program}`;
// };

export const inactivityTime = async (logoutFunc, setCallLogoutFun) => {
  // export const inactivityTime = function async(data) {
  // console.log("inactive time");
  let time;
  document.onload = resetTimer;
  document.onmousemove = resetTimer;
  document.onmousedown = resetTimer; // touchscreen presses
  document.ontouchstart = resetTimer;
  document.onclick = resetTimer; // touchpad clicks
  document.onkeydown = resetTimer;
  window.ontouchmove = resetTimer;
  // function logout() {
  //   alert("You are now logged out.");
  // }
  async function resetTimer() {
    clearTimeout(time);
    setCallLogoutFun(false);
    time = setTimeout(async () => {
      return await logoutFunc(setCallLogoutFun);
    }, 1800000); //logout after 30min, if user is inactive
    // time = setTimeout(async () => {
    //   return await logoutFunc(setCallLogoutFun);
    // }, 10000); //logout after 10sec, if user is inactive
    // time = setTimeout(async () => await autoLogout(data), 10000); //logout after 10sec, if user is inactive
  }
};

// export const clearSessionStorage = (storageName = "") => {
//   storageName && window.sessionStorage.removeItem(storageName);
// };

export const checkCredential = async (data) => {
  // console.log("datat-------", data);
  let loginData = await multiDecryption(data);
  const location = window.location;
  // const loginData = JSON?.parse(sessionStorage?.getItem("uslLoginDetail"));
  const loginPageregex = /^(\/[^\/]*){3}$/; // for LOS login URL
  const salesNewLoginregex = /.*\/.*\/.*\/.*\/SalesLogin/;
  const payLoginPageregex = /.*\/Pay.*\/.*\/.*\//; // for LOS login URL

  if (
    loginData &&
    loginData[constant.LOGINLOGOUT_KEY] === constant.LOGIN_VALUE
  ) {
    return true;
  } else if (
    loginData &&
    loginData[constant.LOGINLOGOUT_KEY] === constant.LOGOUT_VALUE &&
    credentialNotReqForthisURL.includes(location?.pathname)
  ) {
    return true;
  } else if (
    // credentialNotReqForthisURL.includes(location?.pathname) ||
    loginPageregex.test(location?.pathname) ||
    payLoginPageregex.test(location?.pathname) ||
    salesNewLoginregex.test(location?.pathname)
  ) {
    console.log(
      "check new regex working or not ----",
      salesNewLoginregex.test(location?.pathname),
      payLoginPageregex.test(location?.pathname),
      loginPageregex.test(location?.pathname)
    );
    return true;
  }
  // console.log("check cre--261--false");
  return false;
};

export const addScriptFile = (scriptUrls = []) => {
  const scriptPromises = scriptUrls?.map((url) => {
    return new Promise((resolve, reject) => {
      const script = document?.createElement("script");
      script.src = url;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document?.head?.appendChild(script);
    });
  });
  return scriptPromises;
};

export const removeScriptFile = (scriptUrls = []) => {
  scriptUrls?.forEach((url) => {
    const script = document?.querySelector(`script[src="${url}"]`);
    if (script) {
      document?.head?.removeChild(script);
    }
  });
};

export const convertSEcToMin = (apiCountTimer) => {
  const minute = Math.floor(apiCountTimer / 60);
  const sec = apiCountTimer % 60;
  let sec2 = 0;
  if (sec < 10) {
    sec2 = `0${sec}`;
  } else {
    sec2 = sec;
  }
  return `${minute}:${sec2}`;
};

export const updateLocalStorageObj = async (props) => {
  const {
    storageName,
    mobile,
    currTime,
    operation,
    data,
    source,
    anchor,
    program,
  } = props;
  let dataObj = {};
  if (operation === "update") {
    dataObj = { ...data, [currTime]: mobile };
  } else if (operation === "remove") {
    dataObj = data;
    delete dataObj[mobile];
    dataObj = JSON.parse(JSON.stringify(dataObj)); //it has been used to remove the undefined key data
    dataObj = swapKeysAndValues(dataObj);
    if (Object?.keys(dataObj)?.length > 0) {
      let againEncData = {};
      for (const key in dataObj) {
        againEncData[key] = await encryptData(
          `${dataObj[key]}|${source}|${anchor}|${program}`.toString()
        );
      }
      dataObj = againEncData;
    }
  }
  // console.log("dataObj---------", dataObj);
  return dataObj;
  // localStorage.setItem(storageName, JSON.stringify(dataObj));
};

export function swapKeysAndValues(obj) {
  const swappedObj = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      swappedObj[obj[key]] = key;
    }
  }
  return swappedObj;
}

// start for blocking user for 10min
const blockUserLogin = async (
  timeDiff,
  mobile,
  data,
  setCountTimer,
  setRecoilVal,
  source,
  anchor,
  program,
  anchorProgramMatched
) => {
  if (timeDiff <= 1) {
    const objData = {
      storageName: "blocker",
      mobile: mobile,
      currTime: new Date(),
      operation: "remove",
      data: data,
      source: source,
      anchor: anchor,
      program: program,
    };
    setRecoilVal(
      constant?.atomsName?.USER_BLOCKER,
      await updateLocalStorageObj(objData)
    );
    // clearInterval(timer);
    setCountTimer(0);
  }
  // let finalReturn = {timeDiff:timeDiff, anchorProgramMatched:anchorProgramMatched}
  // return timeDiff;
  return { timeDiff, anchorProgramMatched };
};

export const calculateUserBlockTimer = async (
  mobile,
  storedData,
  setCountTimer,
  setRecoilVal,
  source,
  anchor,
  program
) => {
  // let storeData2 = getRecoilVal(constant.atomsName.USER_BLOCKER);
  let storeData1 = await multiDecryption(storedData);
  let currSource = null;
  let currAnchor = null;
  let currProgram = null;
  let anchorProgramMatched = false;
  // console.log("storeData111---------", storeData1);
  for (const key in storeData1) {
    // storeData1[key] = storeData1.key.substr(0, 10);
    // storeData1[key] = storeData1[key].substr(0, 10);
    // console.log("mobile typeof--------", typeof mobile);
    // console.log(
    //   "curr mobile--typeof-------",
    //   typeof storeData1[key].split("|")[0].trim()
    // );
    if (mobile === storeData1[key].split("|")[0].trim()) {
      currSource = storeData1[key].split("|")[1].trim();
      currAnchor = storeData1[key].split("|")[2].trim();
      currProgram = storeData1[key].split("|")[3].trim();
    }
    storeData1[key] = storeData1[key].split("|")[0].trim();
  }
  if (
    currSource === source &&
    currAnchor === anchor &&
    program === currProgram
  ) {
    anchorProgramMatched = true;
  } else {
    anchorProgramMatched = false;
  }
  // console.log("storeData1-----", storeData1);
  let storeData = swapKeysAndValues(storeData1);
  // console.log("storeData--------", storeData);
  for (const key in storeData) {
    // let aa = JSON.parse(key);
    // let a = await decryptData(JSON.parse(key));
    let a = await decryptData(key);
    storeData[a] = storeData.a;
  }
  // console.log("sotreDaattt------", storeData);
  let blockerTime;
  if (storeData?.hasOwnProperty(mobile)) {
    blockerTime = new Date(storeData[mobile]);
  }
  if (blockerTime) {
    // mobile no. is present
    let timeInSec = Math.floor((new Date() - blockerTime) / 1000) || 0;
    let timeDiff = CONSTANTS.BLOCKUSERTIMER - timeInSec;
    setCountTimer(timeDiff);
    return await blockUserLogin(
      timeDiff,
      mobile,
      storeData,
      setCountTimer,
      setRecoilVal,
      source,
      anchor,
      program,
      anchorProgramMatched
    );
  } else {
    return 0;
  }
};
// end for blocking user for 10min

export const VerifyPan = (panNum) =>
  /^([a-zA-Z]){3}([ABCFGHLJPTFabcfghljptf]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$/.test(
    panNum
  );

export const isValidIfsc = (ifsc) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc);

export const onlyNumeric = (num) => /^([0-9])*$/.test(num);

export const twoDecimal = (val) => /^\d+(\.\d{1,2})?$/.test(val);

export const alphanumeric = (alphanum) => /^[a-zA-Z0-9]*$/.test(alphanum);

export const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

export const VerifyMobile = (mobile) => /^([1-9]){1}([0-9]){9}?$/.test(mobile);

export const VerifyUdyam = (udyam) =>
  /^UDYAM-([A-Z]){2}-([0-9]){2}-([0-9]){7}?$/.test(udyam);

export const VerifyAccNo = (acc) => /^[0-9]{9,18}$/.test(acc);

export const randomAlphaNumeric = () => {
  let uniquechar = "";
  const randomchar =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  // Generate captcha for length of
  // 5 with random character
  for (let i = 1; i < 6; i++) {
    uniquechar += randomchar.charAt(Math.random() * randomchar.length);
  }
  return uniquechar;
};

export const refreshCacheAndReload = () => {
  if (caches) {
    // Service worker cache should be cleared with caches.delete()
    caches.keys().then((names) => {
      for (const name of names) {
        caches.delete(name);
      }
    });
  }
  // delete browser cache and hard reload
  // window.location.reload(true);
};
